export default __webpack_public_path__ + "static/media/single-document.61e2b941.svg";